import {SolutionManager} from "./solution-manager";
import {DocFile} from "./doc-file";


export class OrgFile extends SolutionManager {
  orgFileType: OrgFileType;
  docFile: DocFile;
  docFileId: number;

  constructor(managingOrgId?: number) {
    super(managingOrgId);
  }
}

export enum OrgFileType {
  Logo = "LOGO",
  Watermark = "WATERMARK",
  OrgInvoiceLogo = "ORG_INVOICE_LOGO"
}

